import request from '@/router/axios'

export function fetchList() {
    return request({
      url: '/basic/admin/banner/page',
      method: 'get',
    })
  }

export function addObj(obj) {
    return request({
      url: '/basic/admin/banner',
      method: 'post',
      data: obj
    })
  }

export function getObj(id) {
  return request({
    url: '/basic/admin/banner/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/basic/admin/banner/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/basic/admin/banner',
    method: 'put',
    data: obj
  })
}

export function updateBannerSort(query) {
  return request({
    url: `/basic/admin/banner/${query.id}/sort`,
    method: 'PUT',
    data: query
  })
}

export function saveAndPublish(tableData) {
  return request({
    url: '/basic/admin/banner/saveAndPublish',
    method: 'post',
    data: tableData
  })
}

// 同步缓存
export function syncBannerCache(data) {
  return request({
    url: '/basic/admin/banner/sync-cache',
    method: 'post',
    data,
  })
}

// 清除缓存
export function removeBannerCache(data) {
  return request({
    url: '/basic/admin/banner/remove-cache',
    method: 'post',
    data,
  })
}